// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c3e70080","675":"aa11f4e7","985":"7d97b4e6"}[chunkId] + ".chunk.js";
};